import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const currentUser = authService.getCurrentUser();
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!currentUser || !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const user = currentUser.user || currentUser;
  if (requireAdmin && !user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
